export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl mx-auto">
            <div className="bg-background-100 border border-background-200 rounded-3xl p-8 md:p-12">
              <div className="text-center mb-8">
                <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
                  联系我们
                </span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  意见反馈与合作咨询
                </h2>
                <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
                  无论是节目建议、问题反馈还是商务合作，欢迎随时与我们取得联系
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
                <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200 cursor-pointer hover:border-primary-200 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">邮件联系</h3>
                  <p className="text-xs text-foreground-500">contact@51yingshi.com</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200 cursor-pointer hover:border-primary-200 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-wechat-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">微信公众号</h3>
                  <p className="text-xs text-foreground-500">搜索：51影视</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200 cursor-pointer hover:border-primary-200 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                    <i className="ri-weibo-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">官方微博</h3>
                  <p className="text-xs text-foreground-500">@51影视官方</p>
                </div>
              </div>

              <div className="mt-8 p-5 bg-background-50 rounded-xl border border-background-200 text-center">
                <p className="text-foreground-600 text-sm">
                  <i className="ri-information-line mr-1 text-accent-500"></i>
                  如需内容投稿或节目推荐，请通过邮件或微信公众号联系我们，我们会认真阅读每一条反馈。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}